var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _rect, _rect2, _rect3, _circle, _path7, _rect4, _rect5, _g4, _g5, _rect6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _rect7, _rect8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraTutorials3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 306,
    viewBox: "0 0 480 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.633 97.5685C153.409 98.6944 152.953 99.4885 153.297 101.567",
    stroke: "#FEE7BE",
    strokeWidth: 0.724221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.36 98.0029C151.577 99.1952 151.318 99.9708 151.746 101.755",
    stroke: "#FEE7BE",
    strokeWidth: 0.724221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 29,
    width: 245,
    height: 246
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1309 29.7017L292.88 49.8315L272.751 274.576L48.0014 254.447L68.1309 29.7017Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.463 141.587C284.48 139.309 285.08 136.934 285.293 134.553C285.939 127.341 283.014 120.059 277.078 115.107C258.174 99.3328 260.52 103.083 254.957 79.6724C252.634 69.8956 244.009 62.6467 233.636 61.7503C208.772 59.6019 212.968 61.3413 194.177 45.4397C190.252 42.1196 185.444 40.2093 180.506 39.7671C175.568 39.3247 170.498 40.3503 166.046 42.9202C144.601 55.2965 149.101 54.2574 124.316 51.9589C113.948 50.9977 104.172 56.5986 100.149 65.8069C90.5088 87.9064 93.432 84.6052 72.0827 96.7468C65.3613 100.565 61.1897 107.211 60.5438 114.423C60.3305 116.805 60.4978 119.248 61.0926 121.671C66.8296 145.102 67.1922 140.746 57.4186 162.691C56.4028 164.969 55.8042 167.34 55.5904 169.727C54.945 176.934 57.8687 184.22 63.8042 189.176C82.6656 204.914 80.3736 201.168 85.9266 224.602C88.2485 234.389 96.8734 241.632 107.247 242.533C132.111 244.668 127.915 242.946 146.707 258.835C150.632 262.155 155.438 264.07 160.377 264.512C165.315 264.955 170.386 263.924 174.838 261.354C196.146 249.048 191.717 250.016 216.567 252.324C226.934 253.281 236.71 247.686 240.734 238.467C250.378 216.423 247.402 219.697 268.8 207.537C275.521 203.714 279.694 197.064 280.34 189.857C280.554 187.47 280.385 185.03 279.789 182.608C274.044 159.176 273.691 163.529 283.463 141.587Z",
    fill: "#FEE7BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.463 141.587C284.48 139.309 285.08 136.934 285.293 134.552C285.939 127.34 283.014 120.058 277.078 115.107C258.174 99.3324 260.52 103.082 254.957 79.6719C252.634 69.8951 244.009 62.6462 233.636 61.7498C208.772 59.6014 212.968 61.3408 194.177 45.4392C190.252 42.1191 185.444 40.2088 180.506 39.7666C175.568 39.3242 170.498 40.3498 166.046 42.9197C144.601 55.296 149.101 54.2569 124.316 51.9584C113.948 50.9972 104.172 56.5981 100.149 65.8065C90.5088 87.9059 93.432 84.6047 72.0827 96.7463C65.3613 100.564 61.1897 107.21 60.5438 114.422C60.3305 116.804 60.4978 119.248 61.0926 121.67C66.8296 145.102 67.1922 140.745 57.4186 162.691C56.4028 164.969 55.8042 167.339 55.5904 169.726C54.945 176.933 57.8687 184.219 63.8042 189.176C82.6656 204.914 80.3736 201.168 85.9266 224.601C88.2485 234.388 96.8734 241.631 107.247 242.533C132.111 244.668 127.915 242.945 146.707 258.834C150.632 262.154 155.438 264.069 160.377 264.512C165.315 264.954 170.386 263.923 174.838 261.354C196.146 249.048 191.717 250.016 216.567 252.324C226.934 253.28 236.71 247.685 240.734 238.467C250.378 216.423 247.402 219.697 268.8 207.536C275.521 203.713 279.694 197.063 280.34 189.856C280.554 187.469 280.385 185.03 279.789 182.607C274.044 159.176 273.691 163.528 283.463 141.587Z",
    fill: "#FEE7BE"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.005 92.6332L154.105 88.5865L155.396 83.1217C155.623 80.0987 160.069 78.7488 163.073 81.0093L167.985 84.4264L173.397 88.1847C173.994 88.5629 174.167 89.3234 173.785 89.8838C173.402 90.4446 172.608 90.5928 172.012 90.215L166.286 86.9177L165.054 86.209L167.602 90.8588L168.682 93.7161L170.681 100.674L176.941 106.675C177.653 107.253 177.751 108.261 177.161 108.926C176.572 109.592 175.517 109.663 174.806 109.085C174.806 109.085 168.929 104.706 168.365 104.198C167.621 103.526 167.328 103.464 166.77 102.463L164.62 98.0862L160.626 102.735L161.435 110.016C161.582 110.889 160.96 111.695 160.048 111.815C159.136 111.935 158.278 111.324 158.131 110.451L156.586 102.777C156.429 101.942 156.538 101.269 156.835 100.415L160.612 94.2659L157.492 88.3336L157.218 89.4159C157.183 89.7873 157.006 90.1109 156.745 90.3465L156.745 90.3482L156.681 90.4009C156.671 90.4089 156.662 90.4171 156.652 90.4251L151.791 94.4305C151.282 94.8895 150.469 94.8594 149.976 94.3635C149.483 93.8669 149.496 93.0926 150.005 92.6332Z",
    fill: "#FEE7BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.317 79.1011C160.122 77.7846 160.433 75.2967 159.01 73.545C157.587 71.7932 154.97 71.4408 153.165 72.7569C151.359 74.0743 151.049 76.5618 152.472 78.3139C153.894 80.0653 156.512 80.4181 158.317 79.1011Z",
    fill: "#FEE7BE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 88,
    width: 152,
    height: 152
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.453 88.0005L356.478 100.452L344.027 239.475L205.001 227.023L217.453 88.0005Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.654 157.211C351.283 155.802 351.654 154.333 351.786 152.859C352.185 148.398 350.376 143.894 346.704 140.831C335.01 131.073 336.461 133.393 333.02 118.912C331.583 112.864 326.248 108.38 319.831 107.825C304.451 106.496 307.047 107.572 295.423 97.7359C292.995 95.6821 290.021 94.5005 286.967 94.2269C283.912 93.9533 280.775 94.5877 278.022 96.1774C264.756 103.833 267.54 103.19 252.208 101.769C245.795 101.174 239.748 104.639 237.259 110.335C231.296 124.005 233.104 121.963 219.898 129.473C215.74 131.835 213.16 135.946 212.76 140.407C212.628 141.881 212.732 143.392 213.1 144.891C216.649 159.385 216.873 156.69 210.827 170.265C210.199 171.674 209.828 173.141 209.696 174.617C209.297 179.075 211.106 183.582 214.777 186.648C226.444 196.383 225.027 194.066 228.462 208.562C229.898 214.616 235.233 219.096 241.65 219.654C257.03 220.975 254.434 219.909 266.059 229.738C268.487 231.791 271.46 232.976 274.515 233.25C277.57 233.523 280.706 232.886 283.46 231.296C296.641 223.684 293.902 224.283 309.273 225.711C315.686 226.302 321.733 222.841 324.222 217.139C330.188 203.503 328.347 205.528 341.583 198.006C345.741 195.641 348.322 191.527 348.722 187.069C348.854 185.593 348.75 184.084 348.381 182.585C344.827 168.091 344.609 170.783 350.654 157.211Z",
    fill: "#FEE7BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.654 157.21C351.283 155.801 351.654 154.332 351.786 152.859C352.185 148.398 350.376 143.893 346.704 140.83C335.01 131.073 336.461 133.392 333.02 118.911C331.583 112.863 326.248 108.379 319.831 107.825C304.451 106.496 307.047 107.572 295.423 97.7354C292.995 95.6816 290.021 94.5 286.967 94.2264C283.912 93.9528 280.775 94.5872 278.022 96.1769C264.756 103.833 267.54 103.19 252.208 101.768C245.795 101.173 239.748 104.638 237.259 110.334C231.296 124.004 233.104 121.962 219.898 129.473C215.74 131.835 213.16 135.946 212.76 140.407C212.628 141.88 212.732 143.392 213.1 144.89C216.649 159.385 216.873 156.69 210.827 170.265C210.199 171.674 209.828 173.14 209.696 174.617C209.297 179.075 211.106 183.582 214.777 186.648C226.444 196.383 225.027 194.066 228.462 208.561C229.898 214.615 235.233 219.096 241.65 219.653C257.03 220.974 254.434 219.908 266.059 229.737C268.487 231.791 271.46 232.976 274.515 233.249C277.57 233.523 280.706 232.885 283.46 231.296C296.641 223.684 293.902 224.282 309.273 225.71C315.686 226.302 321.733 222.841 324.222 217.138C330.188 203.502 328.347 205.528 341.583 198.005C345.741 195.64 348.322 191.527 348.722 187.069C348.854 185.592 348.75 184.083 348.381 182.585C344.827 168.091 344.609 170.783 350.654 157.21Z",
    fill: "#FEE7BE"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.099 126.928L270.635 124.425L271.433 121.045C271.574 119.175 274.324 118.34 276.182 119.738L279.221 121.852L282.569 124.177C282.938 124.41 283.045 124.881 282.808 125.228C282.572 125.574 282.08 125.666 281.712 125.432L278.17 123.393L277.408 122.954L278.984 125.831L279.652 127.598L280.888 131.902L284.761 135.614C285.201 135.972 285.262 136.595 284.897 137.007C284.532 137.418 283.88 137.462 283.44 137.105C283.44 137.105 279.805 134.396 279.456 134.082C278.996 133.666 278.815 133.628 278.469 133.009L277.139 130.301L274.669 133.177L275.169 137.681C275.26 138.221 274.876 138.719 274.311 138.793C273.747 138.868 273.216 138.49 273.125 137.95L272.169 133.203C272.073 132.687 272.14 132.27 272.323 131.742L274.66 127.938L272.73 124.269L272.56 124.938C272.539 125.168 272.43 125.368 272.268 125.514L272.268 125.515L272.229 125.547C272.222 125.552 272.217 125.557 272.211 125.562L269.203 128.04C268.888 128.324 268.386 128.305 268.081 127.999C267.776 127.691 267.784 127.212 268.099 126.928Z",
    fill: "#FEE7BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.24 118.558C274.357 117.744 274.549 116.205 273.668 115.121C272.789 114.038 271.17 113.82 270.053 114.634C268.936 115.449 268.744 116.988 269.624 118.071C270.504 119.155 272.123 119.373 273.24 118.558Z",
    fill: "#FEE7BE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 47.984,
    rx: 4.28187,
    transform: "matrix(1 0 0 -1 73 183.685)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114.792,
    height: 2.7969,
    rx: 1.39845,
    transform: "matrix(1 0 0 -1 115 151.498)",
    fill: "#FEE7BE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 114.792,
    height: 2.7969,
    rx: 1.39845,
    transform: "matrix(1 0 0 -1 115 159.189)",
    fill: "#FEE7BE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31.3068,
    height: 2.7969,
    rx: 1.39845,
    transform: "matrix(1 0 0 -1 115 167.58)",
    fill: "#FEE7BE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 159.701,
    r: 10,
    fill: "#FDD89E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1058 159.758C98.4742 159.942 98.474 160.468 98.1053 160.652L92.7234 163.34C92.3909 163.506 92 163.264 92 162.893V157.511C92 157.139 92.3914 156.897 92.7238 157.064L98.1058 159.758Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.231,
    y: 22.1588,
    width: 136,
    height: 238.474,
    rx: 15.4654,
    transform: "rotate(10.0265 187.231 22.1588)",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 189.645,
    y: 42.5794,
    width: 123.291,
    height: 201.403,
    rx: 1.32949,
    transform: "rotate(10.0265 189.645 42.5794)",
    fill: "#F8F8F8",
    stroke: "#1A1A1A"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.505 148.055C253.215 148.181 253.718 148.489 254.008 148.956C254.295 149.434 254.376 150.029 254.263 150.731L253.497 155.063L252.786 154.937L252.891 154.343C252.457 154.759 251.906 154.902 251.217 154.78C250.581 154.668 250.097 154.374 249.751 153.919C249.407 153.453 249.285 152.906 249.397 152.269C249.506 151.653 249.798 151.179 250.272 150.847C250.746 150.515 251.312 150.407 251.959 150.521C252.309 150.583 252.605 150.701 252.859 150.877C253.112 151.053 253.298 151.239 253.404 151.444L253.558 150.574C253.655 150.022 253.601 149.585 253.397 149.253C253.193 148.922 252.859 148.709 252.382 148.625C251.926 148.544 251.564 148.612 251.298 148.817C251.134 148.941 251.009 149.094 250.92 149.286L250.399 148.833C250.532 148.637 250.694 148.458 250.894 148.318C251.306 148.03 251.847 147.939 252.505 148.055ZM251.34 154.211C251.785 154.289 252.182 154.206 252.519 153.97C252.867 153.736 253.071 153.389 253.15 152.943C253.228 152.497 253.154 152.112 252.91 151.762C252.664 151.423 252.319 151.209 251.873 151.13C251.417 151.049 251.031 151.134 250.704 151.372C250.376 151.621 250.172 151.968 250.093 152.414C250.016 152.849 250.089 153.245 250.314 153.58C250.549 153.918 250.884 154.13 251.34 154.211Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.896 152.368C277.607 152.494 278.11 152.801 278.399 153.269C278.687 153.747 278.767 154.341 278.654 155.044L277.888 159.376L277.178 159.25L277.283 158.655C276.848 159.071 276.298 159.215 275.609 159.093C274.972 158.98 274.488 158.687 274.142 158.231C273.798 157.766 273.676 157.218 273.789 156.581C273.898 155.966 274.189 155.492 274.664 155.159C275.138 154.827 275.704 154.719 276.351 154.834C276.701 154.895 276.997 155.014 277.25 155.19C277.504 155.366 277.689 155.552 277.795 155.757L277.949 154.886C278.047 154.334 277.993 153.898 277.789 153.566C277.585 153.234 277.251 153.022 276.774 152.937C276.318 152.857 275.956 152.924 275.69 153.129C275.526 153.253 275.4 153.406 275.311 153.599L274.79 153.145C274.923 152.95 275.086 152.77 275.286 152.631C275.698 152.342 276.239 152.252 276.896 152.368ZM275.731 158.523C276.177 158.602 276.574 158.519 276.911 158.283C277.248 158.047 277.462 157.702 277.541 157.256C277.62 156.81 277.546 156.424 277.302 156.075C277.055 155.735 276.71 155.521 276.265 155.442C275.809 155.362 275.422 155.447 275.096 155.685C274.767 155.933 274.564 156.28 274.485 156.726C274.408 157.162 274.48 157.557 274.705 157.893C274.941 158.23 275.275 158.443 275.731 158.523Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.684 147.052L213.156 139.269L214.842 139.567L216.511 148.435L214.888 148.148L214.449 145.684L211.427 145.149L210.18 147.316L208.684 147.052ZM213.672 141.234L212.122 143.938L214.222 144.309L213.672 141.234Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.714 139.749L220.177 140.007L218.623 148.798L217.16 148.54L218.714 139.749Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.103 140.807C221.732 141.114 221.491 141.608 221.369 142.298L221.3 142.691L220.685 142.582L220.456 143.877L221.071 143.986L220.17 149.082L221.633 149.341L222.534 144.245L223.499 144.415L223.728 143.12L222.763 142.949L222.829 142.578C222.872 142.334 222.961 142.141 223.093 142.011C223.238 141.873 223.442 141.832 223.729 141.883L223.951 141.922L224.178 140.638C224.072 140.619 223.926 140.582 223.735 140.548C223.014 140.421 222.462 140.509 222.103 140.807Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.019 143.525L224.556 143.266L223.426 149.658L224.889 149.917L225.599 145.903C225.655 145.585 225.773 145.354 225.949 145.221C226.128 145.077 226.351 145.051 226.692 145.1C226.777 145.115 227.042 145.162 227.042 145.162L227.298 143.718C226.776 143.637 226.321 143.677 225.937 143.992L226.019 143.525Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.156 144.397C229.682 144.205 230.26 144.154 230.865 144.261C231.819 144.429 232.53 144.862 232.984 145.511C233.434 146.182 233.583 147.008 233.414 147.963C233.375 148.186 233.331 148.375 233.29 148.543L228.603 147.715L228.596 147.812C228.569 148.278 228.674 148.669 228.935 148.989C229.196 149.309 229.566 149.505 230.053 149.592C230.753 149.715 231.372 149.496 231.907 148.945L232.863 149.782C232.734 149.956 232.585 150.116 232.419 150.251C232.237 150.416 232.016 150.552 231.763 150.682C231.511 150.813 231.223 150.893 230.888 150.933C230.553 150.972 230.204 150.965 229.833 150.899C228.847 150.725 228.104 150.287 227.615 149.588C227.126 148.888 226.962 148.027 227.138 147.029C227.249 146.402 227.479 145.841 227.833 145.389C228.188 144.926 228.629 144.599 229.156 144.397ZM228.858 146.577L228.831 146.67L231.981 147.227L231.987 147.13C232.023 146.742 231.907 146.404 231.664 146.109C231.419 145.825 231.071 145.632 230.615 145.551C230.19 145.476 229.809 145.529 229.501 145.727C229.182 145.922 228.968 146.202 228.858 146.577Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.057 145.64C236.608 145.431 237.197 145.382 237.822 145.492C238.586 145.627 239.163 145.948 239.548 146.432L239.663 146.584L240.2 143.548L241.78 143.827L240.224 152.629L238.761 152.37L238.9 151.584L238.723 151.717C238.484 151.894 238.189 152.017 237.836 152.097C237.484 152.166 237.1 152.175 236.718 152.107C235.732 151.933 234.991 151.484 234.494 150.772C233.996 150.06 233.829 149.21 234 148.243C234.107 147.638 234.346 147.089 234.7 146.637C235.053 146.185 235.506 145.849 236.057 145.64ZM238.489 150.504C238.907 150.184 239.163 149.725 239.264 149.152C239.364 148.589 239.27 148.069 238.998 147.627C238.705 147.181 238.283 146.909 237.731 146.812C237.159 146.71 236.669 146.821 236.251 147.141C235.846 147.453 235.58 147.909 235.478 148.483C235.375 149.067 235.471 149.576 235.753 150.02C236.046 150.466 236.468 150.738 237.02 150.835C237.582 150.935 238.072 150.824 238.489 150.504Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.355 151.089C242.113 150.356 242.068 149.56 242.218 148.711C242.368 147.861 242.684 147.129 243.163 146.524C243.641 145.918 244.234 145.476 244.946 145.219C245.659 144.961 246.424 144.9 247.252 145.046C247.771 145.138 248.244 145.309 248.683 145.551C249.121 145.792 249.47 146.106 249.753 146.484L249.23 146.907C248.7 146.255 247.994 145.856 247.114 145.7C246.064 145.515 245.154 145.715 244.395 146.293C243.627 146.868 243.149 147.715 242.952 148.829C242.757 149.934 242.928 150.884 243.472 151.702C244.016 152.521 244.804 153.011 245.844 153.195C246.724 153.35 247.576 153.173 248.376 152.668L248.694 153.217C248.355 153.464 247.916 153.66 247.399 153.798C246.883 153.937 246.321 153.958 245.717 153.851C244.889 153.705 244.192 153.384 243.6 152.897C243.008 152.409 242.598 151.822 242.355 151.089Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.797 155.315L255.957 148.754L256.668 148.879L256.54 149.601C256.942 149.125 257.496 148.96 258.185 149.082C258.62 149.159 258.964 149.318 259.208 149.547C259.449 149.787 259.608 150.067 259.682 150.387C259.896 150.107 260.172 149.904 260.491 149.774C260.809 149.644 261.176 149.611 261.579 149.682C261.929 149.744 262.216 149.849 262.461 150.013C262.705 150.177 262.879 150.371 263 150.612C263.122 150.852 263.186 151.105 263.214 151.383C263.241 151.662 263.22 151.965 263.162 152.294L262.391 156.658L261.691 156.534L262.451 152.234C262.547 151.692 262.505 151.247 262.335 150.91C262.165 150.574 261.852 150.365 261.396 150.284C260.961 150.208 260.595 150.296 260.297 150.561C260.009 150.828 259.809 151.219 259.706 151.738L258.944 156.048L258.233 155.923L258.992 151.633C259.088 151.092 259.057 150.648 258.886 150.312C258.716 149.975 258.414 149.768 257.968 149.689C257.512 149.609 257.134 149.706 256.843 149.994C256.551 150.282 256.356 150.707 256.254 151.281L255.519 155.443L254.797 155.315Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.727 158.13L271.887 151.568L272.597 151.694L272.468 152.427C272.633 152.237 272.866 152.092 273.155 152.001C273.445 151.91 273.785 151.904 274.199 151.977C274.209 151.979 274.22 151.981 274.23 151.983L274.107 152.683L273.873 152.642C273.407 152.56 273.032 152.636 272.75 152.871C272.468 153.105 272.28 153.488 272.188 154.009L271.437 158.255L270.727 158.13Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.759 156.881C267.353 156.986 267.876 156.936 268.306 156.728C268.628 156.577 268.944 156.337 269.22 156.014L269.682 156.435C269.377 156.797 269.009 157.082 268.579 157.291C268.004 157.572 267.357 157.644 266.636 157.517C265.66 157.344 264.93 156.897 264.426 156.162C263.932 155.429 263.769 154.557 263.947 153.548C264.124 152.55 264.563 151.796 265.28 151.266C265.997 150.736 266.817 150.552 267.751 150.717C268.694 150.884 269.407 151.306 269.879 151.98C270.352 152.644 270.52 153.484 270.369 154.465C270.337 154.645 270.315 154.773 270.287 154.866L264.656 153.871C264.559 154.664 264.703 155.335 265.078 155.872C265.454 156.41 266.017 156.75 266.759 156.881ZM267.606 151.349C266.949 151.233 266.36 151.348 265.852 151.685C265.344 152.022 264.988 152.55 264.784 153.27L269.662 154.132C269.773 153.385 269.63 152.769 269.247 152.274C268.864 151.78 268.317 151.475 267.606 151.349Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.364 139.751L197.407 129.553L187.385 136.749L185.882 145.253L202.86 148.255L204.364 139.751Z",
    fill: "#FCC35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.861 148.256L193.616 151.001L195.119 142.497L202.861 148.256Z",
    fill: "#FD9728"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.529 111.526C109.812 110.011 111.204 106.028 109.636 102.63L97.7438 108.119C99.3122 111.517 103.246 113.042 106.529 111.526ZM119.907 87.8952C119.738 87.8227 119.562 87.7492 119.378 87.6726C116.601 86.5162 112.163 84.6673 107.906 75.4453C104.458 67.977 96.6346 64.336 89.1296 66.0211L88.2049 64.0181C87.4209 62.3197 85.4541 61.5567 83.8126 62.3144C82.1712 63.0722 81.476 65.0639 82.26 66.7623L83.1846 68.7654C77.0337 73.3839 74.7296 81.6999 78.177 89.1681C82.434 98.3901 80.9616 102.968 80.0407 105.831C79.9797 106.02 79.9211 106.203 79.8668 106.378C79.5953 107.255 79.6901 108.111 80.0297 108.834C80.7676 110.406 82.656 111.353 84.4332 110.533L120.107 94.0654C121.884 93.2451 122.389 91.193 121.671 89.6124C121.34 88.8846 120.75 88.2567 119.907 87.8952Z",
    fill: "#FDD89E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.529 111.526C109.812 110.011 111.204 106.028 109.636 102.63L97.7438 108.119C99.3122 111.517 103.246 113.042 106.529 111.526ZM119.907 87.8952C119.738 87.8227 119.562 87.7492 119.378 87.6726C116.601 86.5162 112.163 84.6673 107.906 75.4453C104.458 67.977 96.6346 64.336 89.1296 66.0211L88.2049 64.0181C87.4209 62.3197 85.4541 61.5567 83.8126 62.3144C82.1712 63.0722 81.476 65.0639 82.26 66.7623L83.1846 68.7654C77.0337 73.3839 74.7296 81.6999 78.177 89.1681C82.434 98.3901 80.9616 102.968 80.0407 105.831C79.9797 106.02 79.9211 106.203 79.8668 106.378C79.5953 107.255 79.6901 108.111 80.0297 108.834C80.7676 110.406 82.656 111.353 84.4332 110.533L120.107 94.0654C121.884 93.2451 122.389 91.193 121.671 89.6124C121.34 88.8846 120.75 88.2567 119.907 87.8952Z",
    stroke: "#FDD89E"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 325.5,
    y: 143.5,
    width: 99,
    height: 99,
    rx: 3.5,
    fill: "white",
    stroke: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 151H353.363V153.545H355.909V151Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 151H363.545V153.545H366.09V151Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 151H371.182V153.545H373.727V151Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 151H373.727V153.545H376.272V151Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 151H378.818V153.545H381.364V151Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 151H386.455V153.545H389.001V151Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 151H391.546V153.545H394.091V151Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 153.545H355.909V156.091H358.455V153.545Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M361 153.545H358.454V156.091H361V153.545Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 153.545H373.727V156.091H376.272V153.545Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 153.545H381.364V156.091H383.91V153.545Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 153.545H386.455V156.091H389.001V153.545Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 153.545H389V156.091H391.545V153.545Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 156.091H361V158.636H363.545V156.091Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 156.091H366.091V158.636H368.636V156.091Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 156.091H376.273V158.636H378.819V156.091Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 156.091H386.455V158.636H389.001V156.091Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 156.091H391.546V158.636H394.091V156.091Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 156.091H394.091V158.636H396.636V156.091Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 158.636H353.363V161.182H355.909V158.636Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 158.636H361V161.182H363.545V158.636Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 158.636H363.545V161.182H366.09V158.636Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 158.636H368.636V161.182H371.181V158.636Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 158.636H373.727V161.182H376.272V158.636Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 158.636H378.818V161.182H381.364V158.636Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 158.636H383.909V161.182H386.455V158.636Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 158.636H391.546V161.182H394.091V158.636Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 161.182H353.363V163.727H355.909V161.182Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 161.182H355.909V163.727H358.455V161.182Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 161.182H361V163.727H363.545V161.182Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 161.182H363.545V163.727H366.09V161.182Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 161.182H366.091V163.727H368.636V161.182Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 161.182H368.636V163.727H371.181V161.182Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 161.182H389V163.727H391.545V161.182Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 161.182H391.546V163.727H394.091V161.182Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 163.727H353.363V166.273H355.909V163.727Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 163.727H361V166.273H363.545V163.727Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 163.727H363.545V166.273H366.09V163.727Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 163.727H376.273V166.273H378.819V163.727Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 163.727H381.364V166.273H383.91V163.727Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 163.727H389V166.273H391.545V163.727Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 163.727H394.091V166.273H396.636V163.727Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 166.272H353.363V168.818H355.909V166.272Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M361 166.272H358.454V168.818H361V166.272Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 166.272H363.545V168.818H366.09V166.272Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 166.272H368.636V168.818H371.181V166.272Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 166.272H373.727V168.818H376.272V166.272Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 166.272H378.818V168.818H381.364V166.272Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 166.272H383.909V168.818H386.455V166.272Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 166.272H389V168.818H391.545V166.272Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 166.272H394.091V168.818H396.636V166.272Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 168.818H353.363V171.363H355.909V168.818Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 168.818H361V171.363H363.545V168.818Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 168.818H368.636V171.363H371.181V168.818Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 168.818H371.182V171.363H373.727V168.818Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 168.818H376.273V171.363H378.819V168.818Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 168.818H378.818V171.363H381.364V168.818Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 168.818H383.909V171.363H386.455V168.818Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 168.818H386.455V171.363H389.001V168.818Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 168.818H389V171.363H391.545V168.818Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 168.818H391.546V171.363H394.091V168.818Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 168.818H394.091V171.363H396.636V168.818Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 171.363H333V173.909H335.545V171.363Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 171.363H343.182V173.909H345.727V171.363Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 171.363H348.272V173.909H350.818V171.363Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 171.363H350.818V173.909H353.364V171.363Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 171.363H353.363V173.909H355.909V171.363Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M361 171.363H358.454V173.909H361V171.363Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 171.363H361V173.909H363.545V171.363Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 171.363H363.545V173.909H366.09V171.363Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 171.363H371.182V173.909H373.727V171.363Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 171.363H376.273V173.909H378.819V171.363Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 171.363H383.909V173.909H386.455V171.363Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 171.363H386.455V173.909H389.001V171.363Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 171.363H389V173.909H391.545V171.363Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 171.363H394.091V173.909H396.636V171.363Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 171.363H396.637V173.909H399.182V171.363Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 171.363H399.182V173.909H401.727V171.363Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 171.363H401.728V173.909H404.273V171.363Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 171.363H404.272V173.909H406.818V171.363Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 171.363H406.818V173.909H409.364V171.363Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M417 171.363H414.454V173.909H417V171.363Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 173.909H335.546V176.455H338.091V173.909Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 173.909H345.728V176.455H348.273V173.909Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 173.909H353.363V176.455H355.909V173.909Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 173.909H355.909V176.455H358.455V173.909Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M361 173.909H358.454V176.455H361V173.909Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 173.909H361V176.455H363.545V173.909Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 173.909H366.091V176.455H368.636V173.909Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 173.909H368.636V176.455H371.181V173.909Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 173.909H371.182V176.455H373.727V173.909Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 173.909H378.818V176.455H381.364V173.909Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 173.909H391.546V176.455H394.091V173.909Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 173.909H396.637V176.455H399.182V173.909Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 173.909H406.818V176.455H409.364V173.909Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 173.909H409.363V176.455H411.909V173.909Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 173.909H411.909V176.455H414.455V173.909Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 176.455H333V179H335.545V176.455Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 176.455H335.546V179H338.091V176.455Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 176.455H340.637V179H343.182V176.455Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 176.455H348.272V179H350.818V176.455Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 176.455H350.818V179H353.364V176.455Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 176.455H353.363V179H355.909V176.455Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M361 176.455H358.454V179H361V176.455Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 176.455H371.182V179H373.727V176.455Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 176.455H376.273V179H378.819V176.455Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 176.455H378.818V179H381.364V176.455Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 176.455H391.546V179H394.091V176.455Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 176.455H396.637V179H399.182V176.455Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 176.455H399.182V179H401.727V176.455Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 176.455H406.818V179H409.364V176.455Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 176.455H411.909V179H414.455V176.455Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 179H333V181.545H335.545V179Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 179H335.546V181.545H338.091V179Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 179H340.637V181.545H343.182V179Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 179H345.728V181.545H348.273V179Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 179H350.818V181.545H353.364V179Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 179H368.636V181.545H371.181V179Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 179H373.727V181.545H376.272V179Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 179H376.273V181.545H378.819V179Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 179H378.818V181.545H381.364V179Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 179H386.455V181.545H389.001V179Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 179H396.637V181.545H399.182V179Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 179H411.909V181.545H414.455V179Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M417 179H414.454V181.545H417V179Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 181.545H333V184.091H335.545V181.545Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 181.545H338.091V184.091H340.636V181.545Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 181.545H340.637V184.091H343.182V181.545Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 181.545H345.728V184.091H348.273V181.545Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 181.545H348.272V184.091H350.818V181.545Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 181.545H350.818V184.091H353.364V181.545Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 181.545H353.363V184.091H355.909V181.545Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M361 181.545H358.454V184.091H361V181.545Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 181.545H361V184.091H363.545V181.545Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 181.545H363.545V184.091H366.09V181.545Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 181.545H366.091V184.091H368.636V181.545Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 181.545H368.636V184.091H371.181V181.545Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 181.545H371.182V184.091H373.727V181.545Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 181.545H376.273V184.091H378.819V181.545Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 181.545H381.364V184.091H383.91V181.545Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 181.545H383.909V184.091H386.455V181.545Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 181.545H386.455V184.091H389.001V181.545Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 181.545H389V184.091H391.545V181.545Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 181.545H394.091V184.091H396.636V181.545Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 181.545H399.182V184.091H401.727V181.545Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 181.545H404.272V184.091H406.818V181.545Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 181.545H406.818V184.091H409.364V181.545Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 181.545H411.909V184.091H414.455V181.545Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M417 181.545H414.454V184.091H417V181.545Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 184.091H333V186.636H335.545V184.091Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 184.091H338.091V186.636H340.636V184.091Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 184.091H340.637V186.636H343.182V184.091Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 184.091H345.728V186.636H348.273V184.091Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M361 184.091H358.454V186.636H361V184.091Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 184.091H366.091V186.636H368.636V184.091Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 184.091H371.182V186.636H373.727V184.091Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 184.091H373.727V186.636H376.272V184.091Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 184.091H383.909V186.636H386.455V184.091Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 184.091H386.455V186.636H389.001V184.091Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 184.091H391.546V186.636H394.091V184.091Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 184.091H396.637V186.636H399.182V184.091Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 184.091H409.363V186.636H411.909V184.091Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 186.636H335.546V189.182H338.091V186.636Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 186.636H343.182V189.182H345.727V186.636Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 186.636H348.272V189.182H350.818V186.636Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 186.636H353.363V189.182H355.909V186.636Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 186.636H355.909V189.182H358.455V186.636Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 186.636H363.545V189.182H366.09V186.636Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 186.636H366.091V189.182H368.636V186.636Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 186.636H368.636V189.182H371.181V186.636Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 186.636H371.182V189.182H373.727V186.636Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 186.636H376.273V189.182H378.819V186.636Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 186.636H378.818V189.182H381.364V186.636Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 186.636H386.455V189.182H389.001V186.636Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 186.636H391.546V189.182H394.091V186.636Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 186.636H394.091V189.182H396.636V186.636Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 186.636H396.637V189.182H399.182V186.636Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 186.636H399.182V189.182H401.727V186.636Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 186.636H404.272V189.182H406.818V186.636Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 186.636H411.909V189.182H414.455V186.636Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 189.182H333V191.727H335.545V189.182Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 189.182H343.182V191.727H345.727V189.182Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 189.182H350.818V191.727H353.364V189.182Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 189.182H361V191.727H363.545V189.182Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 189.182H371.182V191.727H373.727V189.182Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 189.182H373.727V191.727H376.272V189.182Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 189.182H376.273V191.727H378.819V189.182Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 189.182H378.818V191.727H381.364V189.182Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 189.182H383.909V191.727H386.455V189.182Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 189.182H386.455V191.727H389.001V189.182Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 189.182H389V191.727H391.545V189.182Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 189.182H391.546V191.727H394.091V189.182Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 189.182H394.091V191.727H396.636V189.182Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 189.182H396.637V191.727H399.182V189.182Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 189.182H399.182V191.727H401.727V189.182Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 189.182H401.728V191.727H404.273V189.182Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 189.182H404.272V191.727H406.818V189.182Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 191.727H333V194.273H335.545V191.727Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 191.727H338.091V194.273H340.636V191.727Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 191.727H340.637V194.273H343.182V191.727Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 191.727H343.182V194.273H345.727V191.727Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 191.727H345.728V194.273H348.273V191.727Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 191.727H348.272V194.273H350.818V191.727Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 191.727H350.818V194.273H353.364V191.727Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 191.727H355.909V194.273H358.455V191.727Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M361 191.727H358.454V194.273H361V191.727Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 191.727H361V194.273H363.545V191.727Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 191.727H363.545V194.273H366.09V191.727Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 191.727H366.091V194.273H368.636V191.727Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 191.727H376.273V194.273H378.819V191.727Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 191.727H378.818V194.273H381.364V191.727Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 191.727H381.364V194.273H383.91V191.727Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 191.727H386.455V194.273H389.001V191.727Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 191.727H389V194.273H391.545V191.727Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 191.727H391.546V194.273H394.091V191.727Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 191.727H399.182V194.273H401.727V191.727Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 191.727H404.272V194.273H406.818V191.727Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 191.727H411.909V194.273H414.455V191.727Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 194.273H338.091V196.818H340.636V194.273Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 194.273H353.363V196.818H355.909V194.273Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 194.273H355.909V196.818H358.455V194.273Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M361 194.273H358.454V196.818H361V194.273Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 194.273H371.182V196.818H373.727V194.273Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 194.273H373.727V196.818H376.272V194.273Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 194.273H378.818V196.818H381.364V194.273Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 194.273H386.455V196.818H389.001V194.273Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 194.273H391.546V196.818H394.091V194.273Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 194.273H396.637V196.818H399.182V194.273Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 194.273H406.818V196.818H409.364V194.273Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 194.273H409.363V196.818H411.909V194.273Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 194.273H411.909V196.818H414.455V194.273Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 196.818H338.091V199.364H340.636V196.818Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 196.818H345.728V199.364H348.273V196.818Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 196.818H348.272V199.364H350.818V196.818Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 196.818H350.818V199.364H353.364V196.818Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 196.818H353.363V199.364H355.909V196.818Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M361 196.818H358.454V199.364H361V196.818Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 196.818H361V199.364H363.545V196.818Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 196.818H363.545V199.364H366.09V196.818Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 196.818H366.091V199.364H368.636V196.818Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 196.818H371.182V199.364H373.727V196.818Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 196.818H373.727V199.364H376.272V196.818Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 196.818H376.273V199.364H378.819V196.818Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 196.818H378.818V199.364H381.364V196.818Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 196.818H391.546V199.364H394.091V196.818Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 196.818H401.728V199.364H404.273V196.818Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 196.818H406.818V199.364H409.364V196.818Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 196.818H411.909V199.364H414.455V196.818Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 199.364H335.546V201.909H338.091V199.364Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 199.364H338.091V201.909H340.636V199.364Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 199.364H345.728V201.909H348.273V199.364Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 199.364H350.818V201.909H353.364V199.364Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 199.364H353.363V201.909H355.909V199.364Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M361 199.364H358.454V201.909H361V199.364Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 199.364H361V201.909H363.545V199.364Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 199.364H363.545V201.909H366.09V199.364Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 199.364H366.091V201.909H368.636V199.364Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 199.364H376.273V201.909H378.819V199.364Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 199.364H381.364V201.909H383.91V199.364Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 199.364H383.909V201.909H386.455V199.364Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 199.364H386.455V201.909H389.001V199.364Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 199.364H389V201.909H391.545V199.364Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 199.364H394.091V201.909H396.636V199.364Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 199.364H396.637V201.909H399.182V199.364Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 199.364H401.728V201.909H404.273V199.364Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M417 199.364H414.454V201.909H417V199.364Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 201.909H338.091V204.455H340.636V201.909Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 201.909H340.637V204.455H343.182V201.909Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 201.909H345.728V204.455H348.273V201.909Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 201.909H348.272V204.455H350.818V201.909Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 201.909H355.909V204.455H358.455V201.909Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M361 201.909H358.454V204.455H361V201.909Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 201.909H361V204.455H363.545V201.909Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 201.909H363.545V204.455H366.09V201.909Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 201.909H366.091V204.455H368.636V201.909Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 201.909H368.636V204.455H371.181V201.909Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 201.909H371.182V204.455H373.727V201.909Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 201.909H376.273V204.455H378.819V201.909Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 201.909H383.909V204.455H386.455V201.909Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 201.909H386.455V204.455H389.001V201.909Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 201.909H389V204.455H391.545V201.909Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 201.909H394.091V204.455H396.636V201.909Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 201.909H399.182V204.455H401.727V201.909Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 201.909H404.272V204.455H406.818V201.909Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 201.909H406.818V204.455H409.364V201.909Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 201.909H411.909V204.455H414.455V201.909Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M417 201.909H414.454V204.455H417V201.909Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 204.455H333V207H335.545V204.455Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 204.455H343.182V207H345.727V204.455Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 204.455H345.728V207H348.273V204.455Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M353.364 204.455H350.818V207H353.364V204.455Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 204.455H355.909V207H358.455V204.455Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 204.455H363.545V207H366.09V204.455Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 204.455H366.091V207H368.636V204.455Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 204.455H368.636V207H371.181V204.455Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 204.455H371.182V207H373.727V204.455Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 204.455H373.727V207H376.272V204.455Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 204.455H376.273V207H378.819V204.455Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 204.455H378.818V207H381.364V204.455Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 204.455H391.546V207H394.091V204.455Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 204.455H394.091V207H396.636V204.455Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 204.455H401.728V207H404.273V204.455Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 204.455H406.818V207H409.364V204.455Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 204.455H411.909V207H414.455V204.455Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M340.636 207H338.091V209.545H340.636V207Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 207H340.637V209.545H343.182V207Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 207H345.728V209.545H348.273V207Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 207H348.272V209.545H350.818V207Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 207H355.909V209.545H358.455V207Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 207H361V209.545H363.545V207Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 207H363.545V209.545H366.09V207Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 207H368.636V209.545H371.181V207Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 207H371.182V209.545H373.727V207Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 207H378.818V209.545H381.364V207Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 207H383.909V209.545H386.455V207Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 207H386.455V209.545H389.001V207Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 207H389V209.545H391.545V207Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 207H391.546V209.545H394.091V207Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 207H401.728V209.545H404.273V207Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 207H411.909V209.545H414.455V207Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 209.545H343.182V212.091H345.727V209.545Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 209.545H345.728V212.091H348.273V209.545Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 209.545H355.909V212.091H358.455V209.545Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 209.545H361V212.091H363.545V209.545Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 209.545H363.545V212.091H366.09V209.545Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 209.545H371.182V212.091H373.727V209.545Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 209.545H373.727V212.091H376.272V209.545Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 209.545H376.273V212.091H378.819V209.545Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 209.545H386.455V212.091H389.001V209.545Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 209.545H391.546V212.091H394.091V209.545Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 209.545H396.637V212.091H399.182V209.545Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 209.545H401.728V212.091H404.273V209.545Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 209.545H404.272V212.091H406.818V209.545Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M335.545 212.091H333V214.636H335.545V212.091Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M338.091 212.091H335.546V214.636H338.091V212.091Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M343.182 212.091H340.637V214.636H343.182V212.091Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M350.818 212.091H348.272V214.636H350.818V212.091Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 212.091H353.363V214.636H355.909V212.091Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 212.091H355.909V214.636H358.455V212.091Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 212.091H361V214.636H363.545V212.091Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 212.091H363.545V214.636H366.09V212.091Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 212.091H371.182V214.636H373.727V212.091Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 212.091H376.273V214.636H378.819V212.091Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 212.091H381.364V214.636H383.91V212.091Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 212.091H383.909V214.636H386.455V212.091Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 212.091H386.455V214.636H389.001V212.091Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 212.091H389V214.636H391.545V212.091Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 212.091H394.091V214.636H396.636V212.091Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 212.091H396.637V214.636H399.182V212.091Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 212.091H399.182V214.636H401.727V212.091Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 212.091H401.728V214.636H404.273V212.091Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 212.091H404.272V214.636H406.818V212.091Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 214.637H353.363V217.182H355.909V214.637Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 214.637H355.909V217.182H358.455V214.637Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M361 214.637H358.454V217.182H361V214.637Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 214.637H366.091V217.182H368.636V214.637Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 214.637H368.636V217.182H371.181V214.637Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 214.637H371.182V217.182H373.727V214.637Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 214.637H373.727V217.182H376.272V214.637Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 214.637H376.273V217.182H378.819V214.637Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 214.637H378.818V217.182H381.364V214.637Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 214.637H383.909V217.182H386.455V214.637Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 214.637H386.455V217.182H389.001V214.637Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 214.637H394.091V217.182H396.636V214.637Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 214.637H404.272V217.182H406.818V214.637Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 214.637H409.363V217.182H411.909V214.637Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 214.637H411.909V217.182H414.455V214.637Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 217.182H353.363V219.728H355.909V217.182Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 217.182H363.545V219.728H366.09V217.182Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 217.182H368.636V219.728H371.181V217.182Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 217.182H371.182V219.728H373.727V217.182Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 217.182H378.818V219.728H381.364V217.182Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 217.182H383.909V219.728H386.455V217.182Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 217.182H386.455V219.728H389.001V217.182Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 217.182H394.091V219.728H396.636V217.182Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 217.182H399.182V219.728H401.727V217.182Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 217.182H404.272V219.728H406.818V217.182Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 217.182H406.818V219.728H409.364V217.182Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 217.182H411.909V219.728H414.455V217.182Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 219.728H355.909V222.273H358.455V219.728Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M361 219.728H358.454V222.273H361V219.728Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 219.728H361V222.273H363.545V219.728Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 219.728H363.545V222.273H366.09V219.728Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 219.728H368.636V222.273H371.181V219.728Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 219.728H371.182V222.273H373.727V219.728Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 219.728H373.727V222.273H376.272V219.728Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 219.728H376.273V222.273H378.819V219.728Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 219.728H378.818V222.273H381.364V219.728Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 219.728H381.364V222.273H383.91V219.728Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 219.728H386.455V222.273H389.001V219.728Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 219.728H389V222.273H391.545V219.728Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 219.728H394.091V222.273H396.636V219.728Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 219.728H404.272V222.273H406.818V219.728Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M414.455 219.728H411.909V222.273H414.455V219.728Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 222.273H353.363V224.818H355.909V222.273Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M361 222.273H358.454V224.818H361V222.273Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M368.636 222.273H366.091V224.818H368.636V222.273Z",
    fill: "black"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 222.273H368.636V224.818H371.181V222.273Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 222.273H371.182V224.818H373.727V222.273Z",
    fill: "black"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 222.273H376.273V224.818H378.819V222.273Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 222.273H381.364V224.818H383.91V222.273Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 222.273H383.909V224.818H386.455V222.273Z",
    fill: "black"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 222.273H386.455V224.818H389.001V222.273Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 222.273H389V224.818H391.545V222.273Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 222.273H394.091V224.818H396.636V222.273Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 222.273H396.637V224.818H399.182V222.273Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 222.273H399.182V224.818H401.727V222.273Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 222.273H401.728V224.818H404.273V222.273Z",
    fill: "black"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 222.273H404.272V224.818H406.818V222.273Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 222.273H406.818V224.818H409.364V222.273Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M417 222.273H414.454V224.818H417V222.273Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 224.818H355.909V227.364H358.455V224.818Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 224.818H361V227.364H363.545V224.818Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 224.818H371.182V227.364H373.727V224.818Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 224.818H373.727V227.364H376.272V224.818Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 224.818H376.273V227.364H378.819V224.818Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 224.818H394.091V227.364H396.636V224.818Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 224.818H399.182V227.364H401.727V224.818Z",
    fill: "black"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 224.818H401.728V227.364H404.273V224.818Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 224.818H404.272V227.364H406.818V224.818Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 224.818H406.818V227.364H409.364V224.818Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 224.818H409.363V227.364H411.909V224.818Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M361 227.364H358.454V229.909H361V227.364Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 227.364H368.636V229.909H371.181V227.364Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M373.727 227.364H371.182V229.909H373.727V227.364Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 227.364H373.727V229.909H376.272V227.364Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 227.364H376.273V229.909H378.819V227.364Z",
    fill: "black"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M381.364 227.364H378.818V229.909H381.364V227.364Z",
    fill: "black"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 227.364H383.909V229.909H386.455V227.364Z",
    fill: "black"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 227.364H389V229.909H391.545V227.364Z",
    fill: "black"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 227.364H394.091V229.909H396.636V227.364Z",
    fill: "black"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 227.364H399.182V229.909H401.727V227.364Z",
    fill: "black"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M404.273 227.364H401.728V229.909H404.273V227.364Z",
    fill: "black"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M406.818 227.364H404.272V229.909H406.818V227.364Z",
    fill: "black"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 229.909H355.909V232.455H358.455V229.909Z",
    fill: "black"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M366.09 229.909H363.545V232.455H366.09V229.909Z",
    fill: "black"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M371.181 229.909H368.636V232.455H371.181V229.909Z",
    fill: "black"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 229.909H373.727V232.455H376.272V229.909Z",
    fill: "black"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 229.909H376.273V232.455H378.819V229.909Z",
    fill: "black"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M383.91 229.909H381.364V232.455H383.91V229.909Z",
    fill: "black"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M386.455 229.909H383.909V232.455H386.455V229.909Z",
    fill: "black"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 229.909H386.455V232.455H389.001V229.909Z",
    fill: "black"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 229.909H389V232.455H391.545V229.909Z",
    fill: "black"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 229.909H394.091V232.455H396.636V229.909Z",
    fill: "black"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M355.909 232.455H353.363V235H355.909V232.455Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M358.455 232.455H355.909V235H358.455V232.455Z",
    fill: "black"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M361 232.455H358.454V235H361V232.455Z",
    fill: "black"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M363.545 232.455H361V235H363.545V232.455Z",
    fill: "black"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M378.819 232.455H376.273V235H378.819V232.455Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M389.001 232.455H386.455V235H389.001V232.455Z",
    fill: "black"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M391.545 232.455H389V235H391.545V232.455Z",
    fill: "black"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M394.091 232.455H391.546V235H394.091V232.455Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 232.455H394.091V235H396.636V232.455Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M399.182 232.455H396.637V235H399.182V232.455Z",
    fill: "black"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M401.727 232.455H399.182V235H401.727V232.455Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M409.364 232.455H406.818V235H409.364V232.455Z",
    fill: "black"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M417 232.455H414.454V235H417V232.455Z",
    fill: "black"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M348.145 151H335.673H333V153.673V166.145V168.818H335.673H348.145H350.818V166.145V153.673V151H348.145ZM348.145 166.145H335.673V153.673H348.145V166.145Z",
    fill: "black"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M414.327 151H401.854H399.182V153.673V166.145V168.818H401.854H414.327H417V166.145V153.673V151H414.327ZM414.327 166.145H401.854V153.673H414.327V166.145Z",
    fill: "black"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M348.145 217.182H335.673H333V219.855V232.328V235H335.673H348.145H350.818V232.328V219.855V217.182H348.145ZM348.145 232.328H335.673V219.855H348.145V232.328Z",
    fill: "black"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 156.091H338.091V163.727H345.727V156.091Z",
    fill: "black"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M411.909 156.091H404.272V163.727H411.909V156.091Z",
    fill: "black"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M345.727 222.273H338.091V229.909H345.727V222.273Z",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 146,
    width: 94,
    height: 94,
    fill: "url(#pattern0)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 325.5,
    y: 143.5,
    width: 99,
    height: 99,
    rx: 3.5,
    stroke: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.00609756)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.8631,
    height: 54.2018,
    fill: "white",
    transform: "matrix(0.907936 -0.419109 0.419112 0.907935 63 71.9219)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 164,
    height: 164,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraTutorials3);
export default __webpack_public_path__ + "static/media/camera-tutorials-3.4c24868f.svg";
export { ForwardRef as ReactComponent };